import type { ElementOrNested } from './element.no-deps'
import { elementTypeName } from './elementType'

export function elementDisplayName({ label, type }: Pick<ElementOrNested, 'label' | 'type'>) {
    if (!label) {
        return elementTypeName(type)
    }

    return label
}
